import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import ListClients from '../clients/ListClients';
import db from '../../util/database';
import Client from '../../types/Client';
import Tables from '../../util/tables';
import { getChooseQuestionnaire } from '../../util/routes';

function ChooseClient() {
  const history = useHistory();
  const [clients, setClients] = useState<Client[]>([]);
  useEffect(
    () => {
      const getClients = async () => {
        const clients = await db().collection(Tables.CLIENTS).orderBy('updated_at', 'desc').get();
        setClients(clients || []);
      }
      getClients();
    },
    [],
  );
  const onSelectClient = (client: Client) => {
    history.push(getChooseQuestionnaire(client.id));
  }
  return (
    <ListClients clients={clients} onSelect={onSelectClient} />
  );
}

export default ChooseClient;